var map = {
	"./view-bird-animation-1.png": "6640",
	"./view-bird-animation-2.png": "2ebf",
	"./view-bird.png": "fa55",
	"./view-cloud-animation-1.png": "9758",
	"./view-cloud.png": "f679",
	"./view-rain-animation-1.png": "8039",
	"./view-rain-animation-2.png": "e868",
	"./view-rain.png": "b1e7",
	"./view-star-animation-1.png": "13d4",
	"./view-star-animation-2.png": "f3ad",
	"./view-star.png": "4ce2",
	"./view-tree-animation-1.png": "38c9",
	"./view-tree.png": "cf5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f13";